import { IState } from '../../store/reducer';
import { UserGroups } from '../auth/constants';

export const isAdmin = (state: IState) => {
	const impersonating = !!state.entities.admin.isImpersonating;
	const isInGroup = state.entities.auth.session.current.groups.includes(UserGroups.ADMIN);
	return isInGroup && !impersonating;
};
